<template>
  <div
    v-show="showLaps"
    class="lap-container"
    :style="{transform: transformCoef}"
  >
    <record-box
      blue-text="LAP"
      :is-scaled="false"
    >
      <div style="color:#feb942">
        {{ lapPositionState.lap }}
      </div>
      <div>/3</div>
    </record-box>
  </div>
</template>

<script lang="ts">
import {
  RecordBox,
  WindowAspect
} from '@powerplay/core-minigames-ui-ssm'

import { defineComponent } from 'vue'
import { gameConfig } from '@/app/config/gameConfig'
import { lapPositionState } from '@/stores'

export default defineComponent({
  components: {
    RecordBox
  },
  mixins: [WindowAspect],
  data() {

    return {
      lapPositionState: lapPositionState()
    }

  },
  computed: {
    transformCoef() {

      return `scale(${this.scaleCoef})`

    },
    showLaps() {

      return lapPositionState().showLap &&
        lapPositionState().lap > 0 &&
        lapPositionState().lap <= gameConfig.numberOfLaps

    }
  }
})

</script>

<style scoped lang="less">

.lap-container {
  position: absolute;
  top: 1%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  transform-origin: center top;
}
</style>
